import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconLegacyComponent } from './icon.component';

/**
* @deprecated This library has been deprecated in favor of using Icon library that supports SVG please use IconSvgComponent instead
*/
@NgModule({
  imports: [CommonModule],
  declarations: [IconLegacyComponent],
  exports: [IconLegacyComponent],
})
export class RxIconModule {}
